import {
  NS_SET_RUN_INSTANCE_CONFIG,
  NS_GET_RUN_INSTANCE_RESULT_LIST,
  NS_GET_RUN_INSTANCE_RESULT_LIST_FAIL,
  NS_GET_RUN_INSTANCE_RESULT_LIST_SUCCESS,
  NS_GET_RUN_INSTANCE_SUMMARY,
  NS_GET_RUN_INSTANCE_SUMMARY_FAIL,
  NS_GET_RUN_INSTANCE_SUMMARY_SUCCESS,
  NS_GET_RUN_INSTANCE_WATCHLIST_INITIATE,
  NS_GET_RUN_INSTANCE_WATCHLIST_SUCCESS,
  NS_GET_RUN_INSTANCE_WATCHLIST_FAIL,
  NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_INITIATE,
  NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_SUCCESS,
  NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_FAIL,
  NS_GET_RUN_INSTANCE_WHITELIST_INITIATE,
  NS_GET_RUN_INSTANCE_WHITELIST_SUCCESS,
  NS_GET_RUN_INSTANCE_WHITELIST_FAIL,
  NS_GET_ALERT_DETAILS_LIST_DATA,
  NS_GET_ALERT_DETAILS_LIST_DATA_SUCCESS,
  NS_GET_ALERT_DETAILS_LIST_DATA_FAIL,
  NS_POST_HITS_USER_FEEDBACK,
  NS_POST_HITS_USER_FEEDBACK_FAIL,
  NS_POST_HITS_USER_FEEDBACK_SUCCESS,
  NS_POST_DEPLOY_TO_PRODUCTION,
  NS_POST_DEPLOY_TO_PRODUCTION_SUCCESS,
  NS_POST_DEPLOY_TO_PRODUCTION_FAIL,
  NS_SAVE_RUN_INSTANCE,
  NS_SAVE_RUN_INSTANCE_SUCCESS,
  NS_SAVE_RUN_INSTANCE_FAIL,
  NS_POST_RUN_RUN_INSTANCE,
  NS_POST_RUN_RUN_INSTANCE_FAIL,
  NS_POST_RUN_RUN_INSTANCE_SUCCESS,
  NS_GET_RUN_INSTANCE_VIEW_EXECUTION,
  NS_GET_RUN_INSTANCE_VIEW_EXECUTION_SUCCESS,
  NS_GET_RUN_INSTANCE_VIEW_EXECUTION_FAIL,
  NS_GET_CUSTOMER_TYPE,
  NS_GET_CUSTOMER_TYPE_SUCCESS,
  NS_GET_CUSTOMER_TYPE_FAIL,
  NS_POST_CUSTOMER_TYPE,
  NS_POST_CUSTOMER_TYPE_SUCCESS,
  NS_POST_CUSTOMER_TYPE_FAIL,
  NS_PUT_CUSTOMER_TYPE,
  NS_PUT_CUSTOMER_TYPE_SUCCESS,
  NS_PUT_CUSTOMER_TYPE_FAIL,
  NS_DELETE_CUSTOMER_TYPE,
  NS_DELETE_CUSTOMER_TYPE_SUCCESS,
  NS_DELETE_CUSTOMER_TYPE_FAIL
} from '../../actions/ns/runInstance';

export const initialState = {
  isLoading: false,
  alertDetails: {},
  error: null,
  createUpdate: {
    runInstanceConfig: {
      name: '',
      description: '',
      sourceId: ''
    },
    watchListData: [],
    whiteListData: [],
    customerTypeMatchingConfig: null
  },
  runInstanceResultList: { isLoading: false, error: null, data: null },
  runInstanceSummary: { isLoading: false, error: null, data: null },
  hitsUserFeedback: { isLoading: false, error: null, data: null },
  deployToProduction: { isLoading: false, error: null, data: null },
  runRunInstance: { isLoading: false, error: null, data: null },
  runInstanceViewExecution: { isLoading: false, error: null, data: null },
  watchList: { isLoading: false, error: null, data: null },
  whiteList: { isLoading: false, error: null, data: null },
  customerTypeList: {
    isLoading: false,
    error: null,
    data: null
  },
  postCustomerTypeList: {
    isLoading: false,
    error: null,
    data: null
  },
  putCustomerTypeList: {
    isLoading: false,
    error: null,
    data: null
  },
  deleteCustomerTypeList: {
    isLoading: false,
    error: null,
    data: null
  }
};

function nsRunInstanceConfig(state = initialState, action) {
  switch (action.type) {
    case NS_SET_RUN_INSTANCE_CONFIG:
      return {
        ...state,
        createUpdate: {
          ...state.createUpdate,
          ...action.payload
        }
      };
    /**
     * Alert Details
     **/
    case NS_GET_ALERT_DETAILS_LIST_DATA:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case NS_GET_ALERT_DETAILS_LIST_DATA_SUCCESS:
      return {
        ...state,
        alertDetails: action.payload,
        isLoading: false,
        error: null
      };
    case NS_GET_ALERT_DETAILS_LIST_DATA_FAIL:
      return {
        ...state,
        isLoading: false,
        alertList: {},
        alertDetails: { error: { ...action.payload } }
      };
    /**
     * Run Instance List
     **/
    case NS_GET_RUN_INSTANCE_RESULT_LIST:
      return {
        ...state,
        runInstanceResultList: { isLoading: true, error: null, data: null }
      };
    case NS_GET_RUN_INSTANCE_RESULT_LIST_SUCCESS:
      return {
        ...state,
        runInstanceResultList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_GET_RUN_INSTANCE_RESULT_LIST_FAIL:
      return {
        ...state,
        runInstanceResultList: {
          isLoading: false,
          data: null,
          ...action.payload
        }
      };
    /***
     * Run Instance Summary
     ***/
    case NS_GET_RUN_INSTANCE_SUMMARY:
      return {
        ...state,
        runInstanceSummary: { isLoading: true, error: null, data: null }
      };
    case NS_GET_RUN_INSTANCE_SUMMARY_SUCCESS:
      return {
        ...state,
        runInstanceSummary: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_GET_RUN_INSTANCE_SUMMARY_FAIL:
      return {
        ...state,
        runInstanceSummary: { isLoading: false, data: null, ...action.payload }
      };
    /***
     * HIts User Feedback
     ***/
    case NS_POST_HITS_USER_FEEDBACK:
      return {
        ...state,
        hitsUserFeedback: { isLoading: true, error: null, data: null }
      };
    case NS_POST_HITS_USER_FEEDBACK_SUCCESS:
      return {
        ...state,
        hitsUserFeedback: {
          isLoading: false,
          error: null,
          data: action.payload
        }
      };
    case NS_POST_HITS_USER_FEEDBACK_FAIL:
      return {
        ...state,
        hitsUserFeedback: {
          isLoading: false,
          error: action.payload,
          data: null
        }
      };
    /***
     * Run Instance WATCHLIST
     ***/
    case NS_GET_RUN_INSTANCE_WATCHLIST_INITIATE:
      return {
        ...state,
        watchList: { isLoading: true, error: null, data: null }
      };
    case NS_GET_RUN_INSTANCE_WATCHLIST_SUCCESS:
      return {
        ...state,
        watchList: { isLoading: false, data: action.payload, error: null }
      };
    case NS_GET_RUN_INSTANCE_WATCHLIST_FAIL:
      return {
        ...state,
        watchList: { isLoading: false, data: null, ...action.payload }
      };
    case NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_INITIATE:
      return {
        ...state,
        watchList: {
          ...state.watchList,
          watchListCoverageReport: { isLoading: true, data: null, error: null }
        }
      };
    case NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_SUCCESS:
      return {
        ...state,
        watchList: {
          ...state.watchList,
          watchListCoverageReport: {
            isLoading: false,
            data: action.payload,
            error: null
          }
        }
      };
    case NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_FAIL:
      return {
        ...state,
        watchList: {
          ...state.watchList,
          watchListCoverageReport: {
            isLoading: false,
            data: null,
            error: action.payload
          }
        }
      };
    /***
     * Run Instance WHITELIST
     ***/
    case NS_GET_RUN_INSTANCE_WHITELIST_INITIATE:
      return {
        ...state,
        whiteList: { isLoading: true, error: null, data: null }
      };
    case NS_GET_RUN_INSTANCE_WHITELIST_SUCCESS:
      return {
        ...state,
        whiteList: { isLoading: false, data: action.payload, error: null }
      };
    case NS_GET_RUN_INSTANCE_WHITELIST_FAIL:
      return {
        ...state,
        whiteList: { isLoading: false, data: null, ...action.payload }
      };
    /**
     * Deploy To Production
     **/
    case NS_POST_DEPLOY_TO_PRODUCTION:
      return {
        ...state,
        deployToProduction: { isLoading: true, error: null, data: null }
      };
    case NS_POST_DEPLOY_TO_PRODUCTION_SUCCESS:
      return {
        ...state,
        deployToProduction: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_POST_DEPLOY_TO_PRODUCTION_FAIL:
      return {
        ...state,
        deployToProduction: { isLoading: false, data: null, ...action.payload }
      };
    /***
     * Save Run Instance
     ***/
    case NS_SAVE_RUN_INSTANCE:
      return {
        ...state,
        savedNsRunInstance: { isLoading: true, error: null, data: null }
      };
    case NS_SAVE_RUN_INSTANCE_SUCCESS:
      return {
        ...state,
        createUpdate: null,
        savedNsRunInstance: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_SAVE_RUN_INSTANCE_FAIL:
      return {
        ...state,
        savedNsRunInstance: { isLoading: false, data: null, ...action.payload }
      };
    /***
     * Run RunInstance
     ***/
    case NS_POST_RUN_RUN_INSTANCE:
      return {
        ...state,
        runRunInstance: { isLoading: true, error: null, data: null }
      };
    case NS_POST_RUN_RUN_INSTANCE_SUCCESS:
      return {
        ...state,
        runRunInstance: { isLoading: false, data: action.payload, error: null }
      };
    case NS_POST_RUN_RUN_INSTANCE_FAIL:
      return {
        ...state,
        runRunInstance: { isLoading: false, data: null, ...action.payload }
      };
    /**
     * Run Instance - view executions
     **/
    case NS_GET_RUN_INSTANCE_VIEW_EXECUTION:
      return {
        ...state,
        runInstanceViewExecution: { isLoading: true, error: null, data: null }
      };
    case NS_GET_RUN_INSTANCE_VIEW_EXECUTION_SUCCESS:
      return {
        ...state,
        runInstanceViewExecution: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_GET_RUN_INSTANCE_VIEW_EXECUTION_FAIL:
      return {
        ...state,
        runInstanceViewExecution: {
          isLoading: false,
          data: null,
          ...action.payload
        }
      };

    /**
     * GET Customer Type
     **/
    case NS_GET_CUSTOMER_TYPE:
      return {
        ...state,
        customerTypeList: state.customerTypeList
      };
    case NS_GET_CUSTOMER_TYPE_SUCCESS:
      return {
        ...state,
        customerTypeList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_GET_CUSTOMER_TYPE_FAIL:
      return {
        ...state,
        customerTypeList: {
          isLoading: false,
          data: null,
          ...action.payload
        }
      };

    /**
     * POST Customer Type
     **/
    case NS_POST_CUSTOMER_TYPE:
      return {
        ...state,
        postCustomerTypeList: state.postCustomerTypeList
      };
    case NS_POST_CUSTOMER_TYPE_SUCCESS:
      return {
        ...state,
        postCustomerTypeList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_POST_CUSTOMER_TYPE_FAIL:
      return {
        ...state,
        postCustomerTypeList: {
          isLoading: false,
          data: null,
          ...action.payload
        }
      };

    /**
     * PUT Customer Type
     **/
    case NS_PUT_CUSTOMER_TYPE:
      return {
        ...state,
        putCustomerTypeList: state.putCustomerTypeList
      };
    case NS_PUT_CUSTOMER_TYPE_SUCCESS:
      return {
        ...state,
        putCustomerTypeList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_PUT_CUSTOMER_TYPE_FAIL:
      return {
        ...state,
        putCustomerTypeList: {
          isLoading: false,
          data: null,
          ...action.payload
        }
      };

    /**
     * DELETE Customer Type
     **/
    case NS_DELETE_CUSTOMER_TYPE:
      return {
        ...state,
        deleteCustomerTypeList: {
          isLoading: false,
          data: action.type,
          error: null
        }
      };
    case NS_DELETE_CUSTOMER_TYPE_SUCCESS:
      return {
        ...state,
        deleteCustomerTypeList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case NS_DELETE_CUSTOMER_TYPE_FAIL:
      return {
        ...state,
        deleteCustomerTypeList: {
          isLoading: false,
          data: action.type,
          error: null
        }
      };

    default:
      return {
        ...state
      };
  }
}

export default nsRunInstanceConfig;
